module.exports = __webpack_public_path__ + "img/medical_sign.b727532e.jpg";